import React, { useState, useContext, useEffect } from 'react'
import { Button, Label, Input, FormGroup, Modal } from 'reactstrap'
import { apiUserLogin, apiUserLoginVerify } from '../../services/api-service'
import { times } from 'lodash'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import { AuthContext } from '../../context/AuthContextProvider'
import { ModalContext } from '../../context/ModalContextProvider'
import PropTypes from 'prop-types'

const OtpNumber = (props) => {
  const [otp, setOtp] = useState({})
  const { setAuthState, mobileNumberState } = useContext(AuthContext)
  const { setGlobalLoader, setGlobalMessage, otpTimerState, setOtpTimerState } = useContext(MessageHandlerContext)
  const {
    nicModal, setNicModal,
    purchaseConfirmModal, setPurchaseConfirmModal
  } = useContext(ModalContext)

  useEffect(() => {
    const timer =
      otpTimerState > 0 && setInterval(() => setOtpTimerState(otpTimerState - 1), 1000)
    return () => clearInterval(timer)
  }, [otpTimerState])

  const focusChange = (e, index) => {
    const fields = { ...otp }
    const { maxLength, value } = e.target
    if (value.length === maxLength) {
      fields[index] = value
      const nextSibling = document.querySelector(`input.otpbox[name=otp_${parseInt(index + 1, 10) + 1}]`)
      if (nextSibling !== null) {
        nextSibling.focus()
      }
    } else {
      fields[index] = ''
    }
    setOtp(fields)
  }

  const verifyOtp = async () => {
    let otpCode = ''
    Object.values(otp).forEach(element => { otpCode = otpCode.concat(element) })
    if (otpCode.length === 4) {
      setGlobalLoader(true)
      try {
        const userVerification = await apiUserLoginVerify({ mobile: mobileNumberState, otp: otpCode })
        if (userVerification.status === 200) {
          setAuthState(userVerification.data)
          props.toggle()
          if (!userVerification.data.nic) {
            setNicModal(!nicModal)
          } else {
            setPurchaseConfirmModal(!purchaseConfirmModal)
          }
        } else {
          setOtp({})
          setGlobalMessage(userVerification.data.description)
        }
      } catch (error) {
        setOtp({})
        setGlobalMessage(error.message)
      } finally {
        setGlobalLoader(false)
      }
    } else {
      setGlobalMessage('Invalid OTP')
    }
  }

  const resendOtp = async () => {
    setOtp({})
    setOtpTimerState(60)
    apiUserLogin({ mobile: mobileNumberState })
  }

  return (
    <Modal isOpen={props.opened} toggle={props.toggle} backdrop="static">
      <div className="login_otp">
        <div className="login_otp_wrapper">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Label for="mobileNumber">Enter OTP</Label>
            {
              (otpTimerState === 0)
                ? (<Label style={{ color: '#FF8F00' }} onClick={() => resendOtp()}>Resend</Label>)
                : (<Label>Resend OTP in: {otpTimerState}</Label>)
            }
          </div>
          <FormGroup>
            {
              times(4, (index) => {
                return <Input
                  className="otpbox"
                  autoComplete="off"
                  type="number"
                  name={'otp_' + (index + 1)}
                  value={otp[index] || ''}
                  pattern="\d*"
                  maxLength={1}
                  onChange={(event) => focusChange(event, index)}
                  key={index}
                />
              })
            }
          </FormGroup>
          <FormGroup className="mb-0">
            <Button color="warning" block onClick={() => verifyOtp()}>Submit</Button>
          </FormGroup>
        </div>
      </div>
    </Modal>
  )
}

OtpNumber.propTypes = {
  opened: PropTypes.bool,
  toggle: PropTypes.func
}

export default OtpNumber
